import { render } from "./page-404.vue?vue&type=template&id=4c2a6baa"
import script from "./page-404.vue?vue&type=script&lang=js"
export * from "./page-404.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__